module.exports = __webpack_public_path__ + "bin/18b2e0e5e20a046f6981401c72541bb9.jpg";